import Box from "@material-ui/core/esm/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValueLoadable } from 'recoil';
import { getInvoicePagination, getInvoices } from 'api/invoices/getInvoices';
import Pagination from 'components/Pagination/Pagination';
import PeriodFilter from 'components/PeriodFilter/PeriodFilter';
import Spinner from 'components/Spinner/Spinner';
import { Title } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import checkLoadable from 'utils/recoil/checkLoadable';
import InvoiceList from '../InvoiceList/InvoiceList';
export default function AllInvoices() {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  const [invoicesPagination, setInvoicesPagination] = useRecoilState(getInvoicePagination);
  const loadableAllInvoices = useRecoilValueLoadable(getInvoices(customer?.id));
  const {
    contents: allInvoices,
    loading
  } = checkLoadable(loadableAllInvoices);
  const onPeriodFilterChange = async ({
    startDate,
    endDate
  }) => {
    const dateTo = endDate?.toDate();
    const dateFrom = startDate?.toDate();
    setInvoicesPagination({
      ...invoicesPagination,
      dateFrom,
      dateTo
    });
  };
  const invoicesCount = allInvoices?.totalResults;
  let content;
  if (loading) {
    content = /*#__PURE__*/React.createElement(Spinner, null);
  } else {
    content = invoicesCount !== 0 ? /*#__PURE__*/React.createElement(InvoiceList, {
      filteredResults: allInvoices?.results
    }) : /*#__PURE__*/React.createElement(Title, {
      align: "center"
    }, t('invoices.no_invoice'));
  }
  return /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    position: "relative"
  }, /*#__PURE__*/React.createElement(PeriodFilter, {
    useUtc: true,
    onChange: onPeriodFilterChange
  }), content, /*#__PURE__*/React.createElement(Pagination, {
    totalResults: invoicesCount ?? 0,
    handlePagination: setInvoicesPagination,
    paginationParams: invoicesPagination
  }));
}